export default {
  404: {
    title: '404 Página no encontrada',
    text: 'La página que estás buscando no está disponible.<br /> Intenta volver a la página de inicio o inténtalo de nuevo más tarde.',
  },
  500: {
    title: '500 Error Interno del Servidor',
    text: 'Lo siento, ha ocurrido un error interno. <br />Estamos trabajando para solucionar el problema lo antes posible. <br /> Intenta volver a la página de inicio o inténtalo de nuevo más tarde.',
  },
}
